<script>
  import { onMount } from "svelte";
  import { getNextInputId } from "../../helper/UIHelper";

  import Pickr from "@simonwep/pickr";

  export let model;
  export let swatches;
  export let saveOnSelect = false;
  export let emptyStart = false;

  let className = '';
  export {className as class};
  let pickr;
  let container;

  let uid = getNextInputId();
  let defaultSwatches = [
        "#C90920",
        "#E84E1B",
        "#ECB304",
        "#93C01F",
        "#00A099",
        "#2C60AB",
        "#D60B51",
  ];
  if(swatches){
      defaultSwatches = [];
    for(let i = 0; swatches.length > i; i++){
      if(swatches[i] != null){
        defaultSwatches.push(`rgb(${swatches[i][0]}, ${swatches[i][1]}, ${swatches[i][2]})`)
      }
    }
    
  }
  console.log(defaultSwatches);
  const defaultColor = emptyStart ? null : '#C90920';
  if(model.hex == null)
    model.hex = defaultColor;
  onMount(() => {
    console.log(swatches);
    pickr = Pickr.create({
      el: `#${uid}`,
      theme: "nano", // classic or 'monolith', or 'nano'
      default: model.hex != null ? model.hex : defaultColor,
      appClass: saveOnSelect ? 'save-on-select-mode' : '',
      swatches: defaultSwatches,
      showAlways: saveOnSelect,
      lockOpacity: true,
      autoReposition: !saveOnSelect,
      inline: saveOnSelect,
      components: {
        // Main components
        preview: true,
        opacity: true,
        hue: true,

        // Input / output Options
        interaction: {
          hex: false,
          rgba: false,
          hsla: false,
          hsva: false,
          cmyk: false,
          input: true,
          save: !saveOnSelect
        }
      }
    });

    pickr.on("save", (color, instance) => {
      if (color != null){
        model.hex = color.toHEXA().toString();
        model.rgbaObject = color.toRGBA(); 
      } 
      pickr.hide();
    }).on('cancel', instance => {
        pickr.hide();
    }).on('init', instance => {
      console.log(instance)
      if(swatches != null && model.hex == null && !emptyStart)
        pickr.setColor(`rgb(${swatches[0][0]}, ${swatches[0][1]}, ${swatches[0][2]})`);
        model.rgbaObject = instance._color.toRGBA(); 
      if(saveOnSelect)
        pickr.show()  
      })
    .on('change', (color, instance) => {
     if (color != null){
         model.hex = color.toHEXA().toString();
         model.rgbaObject = color.toRGBA(); 
      } 
})

  });
</script>

<!-- https://github.com/Simonwep/pickr -->
<div bind:this={container} class:save-on-select-mode={saveOnSelect} class:empty-start-mode={emptyStart} class={className}>
  <div id={uid} />
</div>
<style>
:global(.save-on-select-mode .pickr){
  display:none!important;
}
:global(.save-on-select-mode .pcr-app){
  margin: 0 auto!important;
}

:global(.empty-start-mode .pickr){
  width: 100%!important;
    height: 100%!important;
}
:global(.empty-start-mode .pcr-button){
  width: 100%!important;
    height: 100%!important;
}

:global(.empty-start-mode .pcr-button.clear){
  background: none!important;
}

:global(.empty-start-mode .pcr-button::after){
 border-radius: 0!important;
}

:global(.empty-start-mode .pcr-button.clear::after){
  background: none!important;
      content: "+";
    font-size: 38px;
}
</style>